import { useEffect, useState } from 'react'
import { getTokenTimeRemaining } from '../services/authorizationService'
import toast from 'react-hot-toast'

/**
 * Componente que muestra una advertencia cuando faltan 5 minutos para que expire el token
 */
const TokenExpirationWarning = () => {
    const [showWarning, setShowWarning] = useState(false)
    const [timeRemaining, setTimeRemaining] = useState(null)
    const WARNING_TIME_SECONDS = 300 // 5 minutos

    useEffect(() => {
        const warningInterval = setInterval(() => {
            const remaining = getTokenTimeRemaining()
            setTimeRemaining(remaining)

            // Si faltan menos de 5 minutos y más de 0 segundos
            if (remaining > 0 && remaining <= WARNING_TIME_SECONDS) {
                if (!showWarning) {
                    setShowWarning(true)
                    // Mostrar notificación persistente
                    toast.error(
                        (t) => (
                            <div className='flex flex-col gap-2'>
                                <p className='font-bold'>⚠️ Sesión por expirar</p>
                                <p>Tu sesión caduca en {remaining} segundos</p>
                                <p className='text-sm'>Por favor, guarda tus cambios.</p>
                            </div>
                        ),
                        {
                            duration: Infinity,
                            id: 'token-expiration-warning'
                        }
                    )
                }
            } else if (remaining <= 0) {
                // El token ya expiró
                toast.dismiss('token-expiration-warning')
                setShowWarning(false)
            }
        }, 10000) // Actualizar cada 10 segundos

        return () => clearInterval(warningInterval)
    }, [showWarning])

    return null // Este componente solo maneja la lógica, no renderiza nada
}

export default TokenExpirationWarning
